import {
  createBrowserRouter,
  RouterProvider,
} from 'react-router';
import { AppShell } from './components/layout/AppShell';
import { ArchitecturePage } from './pages/ArchitecturePage';
import { ContactPage } from './pages/ContactPage';
import { DashboardPage } from './pages/DashboardPage';
import { ExperiencePage } from './pages/ExperiencePage';
import { HomePage } from './pages/HomePage';
import { ProjectCaseStudyPage } from './pages/ProjectCaseStudyPage';
import { ProjectsPage } from './pages/ProjectsPage';
import { ResumePage } from './pages/ResumePage';
import { ShowcasePage } from './pages/ShowcasePage';
import { SkillsPage } from './pages/SkillsPage';

const router = createBrowserRouter([
  {
    path: '/',
    element: <AppShell />,
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: 'dashboard',
        element: <DashboardPage />,
      },
      {
        path: 'projects',
        element: <ProjectsPage />,
      },
      {
        path: 'projects/:projectSlug',
        element: <ProjectCaseStudyPage />,
      },
      {
        path: 'showcase',
        element: <ShowcasePage />,
      },
      {
        path: 'architecture',
        element: <ArchitecturePage />,
      },
      {
        path: 'experience',
        element: <ExperiencePage />,
      },
      {
        path: 'skills',
        element: <SkillsPage />,
      },
      {
        path: 'resume',
        element: <ResumePage />,
      },
      {
        path: 'contact',
        element: <ContactPage />,
      },
    ],
  },
]);

export default function App() {
  return <RouterProvider router={router} />;
}